module.exports = __webpack_public_path__ + "static/img/banner.c270a6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/haierProduct/images/banner.jpg
// module id = l6Dw
// module chunks = 4